<template>
  <div>
    <h1>Logout</h1>
    <p>You have been logged out.</p>
  </div>
</template>

<script>
import apiService from '@/services/apiService';

export default {
  name: 'LogoutPage',
  created() {
    // Clear the auth data using the new system
    apiService.clearAuthData();

    // Clear legacy data
    localStorage.removeItem('loggedIn');
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('username');

    this.$router.push('/login');
  }
};
</script>
